import React, {Component} from 'react';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import { withStyles } from '@material-ui/core/styles';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';
import logo from './emclogo.png'; 
import flow from './flow.jpg'; 
import Iframe from 'react-iframe'

const styles = {
 
    card2: {
        alignItems:'center',
        align: 'center',
        boxShadow: 'none',
        border:'none',
        // height:'100%',
        // width:'100vw',
        // minHeight: 700,
        // minWidth: 725,
        marginLeft:'auto',
        marginRight: 'auto'
    },
    myClassname:{

    }
  };

class ChatBoxMobile extends Component {

    state={
        height:'30vh',
        width:'30vw'
    };

    componentDidMount(){
        setInterval(()=>{
            this.setState({
                height:'100vh',
                width:'100vw'
            })
        },3000)
    }

    render(){
        const { classes, src } = this.props; 
        let fileURL = "";
        if (this.props.lang == "en"){
            fileURL = __dirname + 'chatbot.html'
        }
        else if (this.props.lang == "cn"){
            fileURL = __dirname + 'chatbot_chi.html'
        }
        
        return(
            <div style={{height:this.state.height, width:this.state.width}}>
                <Iframe url={fileURL}
                    position="relative"
                    // width="60%"
                    // height="100%"
                    // height="100%"
                    id="myId"
                    className="myClassname"
                    />
            </div>
        );
    }
}

export default withStyles(styles)(ChatBoxMobile);